<div class="app__container">
    <div class="app__container-header">
        <div class="app__container-title">
            <h1 class="type__h1-heavy">BPM Upload Tool</h1>
        </div>
    </div>    
</div>

<router-outlet></router-outlet>
